import { createContext, useContext } from 'react';

// Whether the screen is being shown as a phone, and so whether the phone's own
// system chrome — the clock, the signal bars, the battery — belongs on it.
//
// A context rather than a prop because StatusBar has fifty-odd call sites: the
// screens are drawn for a phone and say so, and it is the stage around them that
// knows when they are not on one. Default true, so a screen renders as a phone
// unless something says otherwise.
export const SystemChromeContext = createContext(true);

export const useSystemChrome = () => useContext(SystemChromeContext);
